import { useContext } from 'react';
import Button from '@classify/react-core-components/Button';
import { translate } from '@openclassrooms/translations';
import { alpha } from '@classify/react-core-components/styles';

/* eslint-disable-next-line import/no-extraneous-dependencies */
import { useUnfollowCourse } from '@openclassrooms/data-connect-web/learning-activity';
import CourseContext from '../../contexts/courseContext';

function UnfollowCourseButton() {
  const { course, currentUser, refetchCourseData } = useContext(CourseContext);
  const [, { isLoading, mutateAsync: unfollowCourse }] = useUnfollowCourse();
  const { categoryColor } = course;

  const handleContinueCourse = () => {
    unfollowCourse(
      { courseId: String(course.id), userId: currentUser.id },
      { onSuccess: () => refetchCourseData() }
    );
  };

  return (
    <Button
      isLoading={isLoading}
      onClick={handleContinueCourse}
      sx={{
        color: `${categoryColor} !important`,
        '&:hover': {
          background: `${alpha(categoryColor, 0.24)} !important`,
          color: `${categoryColor} !important`,
        },
      }}
      variant="tertiary"
    >
      {translate('course.unfollow.button')}
    </Button>
  );
}

export default UnfollowCourseButton;
